<div class="alarm-details-content">
  <div class="details-card">
    <div class="card-header">
      <!-- Fila superior: título + acciones -->
      <div class="header-top-row">
        <div class="header-title-block">
          <h2>Monitor de Alarmas</h2>
          <p>Información de última posición de los vehículos</p>
        </div>
        <div class="header-actions">
          <div class="cluster-toggle-wrapper">
            <i class="material-icons toggle-icon">{{ clusteringEnabled ? 'blur_on' : 'blur_off' }}</i>
            <span class="toggle-label">Clusters</span>
            <mat-slide-toggle [checked]="clusteringEnabled" (change)="toggleClusteringEvent.emit()" color="primary">
            </mat-slide-toggle>
          </div>
        </div>
      </div>

      <!-- Fila de filtros -->
      @if (alarms.length > 0 && !isRiskEvaluation) {
        <div class="header-filters-row">
          <div class="filter-search-input">
            <i class="material-icons">search</i>
            <input type="text" placeholder="Buscar por placa, nombre, evento..." [(ngModel)]="filterText"
              (input)="applyFilters()" />
            @if (filterText) {
              <i class="material-icons filter-clear-icon" (click)="filterText = ''; applyFilters()">close</i>
            }
          </div>
          <button class="filter-toggle-btn" (click)="toggleFilters()" [class.active]="showFilters || hasActiveFilters">
            <i class="material-icons">directions_car</i>
            @if (selectedUnits.size > 0) {
              <span class="filter-active-dot"></span>
            }
          </button>
        </div>

        @if (hasActiveFilters) {
          <div class="header-filter-summary">
            <span class="filter-result-count">
              {{ filteredAlarms.length }} de {{ alarms.length }} alarmas
            </span>
            <button class="filter-clear-btn" (click)="clearFilters()">
              <i class="material-icons">filter_list_off</i> Limpiar
            </button>
          </div>
        }

        <!-- Panel desplegable de unidades -->
        @if (showFilters) {
          <div class="unit-filter-panel">
            <div class="unit-filter-header">
              <span class="unit-filter-title">Filtrar por unidades</span>
              <div class="unit-filter-actions">
                <button class="unit-action-btn" (click)="selectAllUnits()">Todas</button>
                <span class="unit-action-sep">|</span>
                <button class="unit-action-btn" (click)="deselectAllUnits()">Ninguna</button>
              </div>
            </div>
            <div class="unit-search-input">
              <i class="material-icons">search</i>
              <input type="text" placeholder="Buscar unidad..." [(ngModel)]="unitSearchText" />
            </div>
            <div class="unit-list">
              @for (unit of filteredUnits; track unit.assetId) {
                <label class="unit-item" [class.selected]="selectedUnits.has(unit.assetId)">
                  <input type="checkbox" [checked]="selectedUnits.has(unit.assetId)" (change)="toggleUnit(unit.assetId)" />
                  <span class="unit-name">{{ unit.assetName }}</span>
                  <span class="unit-plate">{{ unit.assetId }}</span>
                </label>
              }
              @if (filteredUnits.length === 0) {
                <div class="unit-empty">Sin unidades encontradas</div>
              }
            </div>
          </div>
        }
      }
    </div>
    <div class="divider"></div>

    <div class="card-content" #scrollContainer>
      <div class="alarm-info-grid">

        <!-- Indicador de fin de datos -->
        <!-- Lista de alarmas con infinite scroll -->
        @if (alarms.length > 0 && !isRiskEvaluation) {
          <div class="alarms-scroll-list">
            @for (alarm of filteredAlarms; track alarm.id ? alarm.id + '-' + $index : $index; let i = $index) {
              <div class="alarm-card-scroll" [class.new-alarm]="newAlarmIds?.has(alarm.id)"
                [style.border-left-color]="alarm.color || '#172c41'" (click)="onAlarmCardClick(alarm)">
                <div class="alarm-card-header">
                  <i class="material-icons alarm-card-icon" [style.color]="getIconColor(alarm)">warning</i>
                  <span class="alarm-card-title">{{ alarm.gpsReport?.eventName || 'Evento' }}</span>
                  @if (newAlarmIds?.has(alarm.id)) {
                    <span class="new-alarm-badge" style="background:#e91e63;color:#fff;border-radius:10px;padding:2px 8px;font-size:11px;margin-left:8px;">Nueva</span>
                  }
                  <button type="button" class="classify-btn" (click)="openClassificationModal(alarm)">
                    <i class="material-icons" [style.color]="alarm.color || '#172c41'">assignment</i>
                    <span>Clasificar</span>
                  </button>

                </div>
                <div class="alarm-card-body">
                  @if (alarm.reviewingByName) {
                    <div class="alarm-card-row" [class.selected-review]="selectedAlarmId && selectedAlarmId === alarm.id">
                      <i class="material-icons reviewing-icon">contact_emergency</i>
                      <span class="reviewing-name">{{ alarm.reviewingByName }}</span>
                    </div>
                  }

                  <div class="alarm-card-row">
                    <i class="material-icons">local_shipping</i>
                    <span>{{ alarm.gpsReport?.assetName || 'N/A' }}</span>
                    <span class="alarm-card-plate">{{ alarm.gpsReport?.assetId || '' }}</span>
                  </div>

                  <div class="alarm-card-row">
                    <i class="material-icons">place</i>
                    <span class="alarm-card-location">{{ alarm.gpsReport?.location || 'Sin ubicación' }}</span>
                  </div>
                  <div class="alarm-card-row">
                    <i class="material-icons">schedule</i>
                    <span>{{ $safeNavigationMigration(alarm.gpsReport?.reportDate) | date:'dd/MM/yyyy HH:mm' }}</span>
                    @if (alarm.gpsReport?.speed != null) {
                      <span class="alarm-card-speed">
                        <i class="material-icons">speed</i> {{ alarm.gpsReport.speed }} km/h
                      </span>
                    }
                  </div>
                </div>
              </div>
            }

            <!-- Indicador de carga al hacer scroll -->
            @if (isLoadingAlarms) {
              <div class="scroll-loading-indicator">
                <mat-spinner diameter="28"></mat-spinner>
                <span>Cargando más alarmas...</span>
              </div>
            }

            @if (!hasMoreAlarms && alarms.length > 0 && !hasActiveFilters) {
              <div class="scroll-end-indicator">
                <span>Se mostraron todas las alarmas ({{ alarms.length }})</span>
              </div>
            }

            <!-- Sin resultados con filtros activos -->
            @if (filteredAlarms.length === 0 && hasActiveFilters) {
              <div class="no-filter-results">
                <i class="material-icons">filter_list_off</i>
                <span>No hay alarmas que coincidan con los filtros</span>
                <button class="filter-clear-link" (click)="clearFilters()">Limpiar filtros</button>
              </div>
            }
          </div>
        }

        <!-- Modal de clasificación (placeholder para el formulario que pegarás) -->
        @if (showClassificationModal) {
          <div class="modal-backdrop" (click)="closeClassificationModal()">
            <div class="modal" (click)="$event.stopPropagation()">
              <form [formGroup]="classificationForm" (ngSubmit)="clasificarAlerta(modalAlarm)" class="classification-form">
                <div class="modal-header">
                  <h3>Clasificar Alarma</h3>
                  <button class="modal-close-btn" (click)="closeClassificationModal()"><i class="material-icons">close</i></button>
                </div>
                <div class="modal-body">
                  <div class="classification-form-container">
                    <div class="form-group">
                      <label class="checkbox-inline">
                        <input type="checkbox" formControlName="bulkClassification" (change)="onBulkChange()" />
                        Clasificación por lote
                      </label>
                    </div>
                    <!-- Lista de alarmas para selección bulk -->
                    @if (classificationForm.get('bulkClassification')?.value) {
                      <div class="bulk-alarms-section">
                        <div class="bulk-alarms-header">
                          <span class="bulk-alarms-count">
                            {{ selectedAlarmIds.size }} de {{ bulkTotalElements }} alarmas seleccionadas
                          </span>
                          <div class="bulk-alarms-actions">
                            <button type="button" class="unit-action-btn" (click)="selectAllBulkAlarms()">Todas</button>
                            <span class="unit-action-sep">|</span>
                            <button type="button" class="unit-action-btn" (click)="deselectAllBulkAlarms()">Ninguna</button>
                          </div>
                        </div>
                        <div class="bulk-alarms-list" (scroll)="onBulkListScroll($event)">
                          @for (alarm of bulkAlarms; track alarm.id ?? $index; let i = $index) {
                            <label class="bulk-alarm-item" [class.selected]="selectedAlarmIds.has(alarm.id)"
                              [style.border-left-color]="alarm.color || '#172c41'">
                              <input type="checkbox" [checked]="selectedAlarmIds.has(alarm.id)"
                                (change)="toggleAlarmSelection(alarm.id)" />
                              <div class="bulk-alarm-info">
                                <span class="bulk-alarm-event" [style.color]="alarm.color || '#172c41'">{{
                                alarm.gpsReport?.eventName || 'Evento' }}</span>
                                <span class="bulk-alarm-asset">{{ alarm.gpsReport?.assetName || 'N/A' }} &middot; {{
                                alarm.gpsReport?.assetId || '' }}</span>
                                <span class="bulk-alarm-location">{{ alarm.gpsReport?.location || 'Dirección' }}</span>
                                <span class="bulk-alarm-date">{{ $safeNavigationMigration(alarm.gpsReport?.reportDate) | date:'dd/MM/yyyy HH:mm'
                                }}</span>
                              </div>
                            </label>
                          }
                          @if (isLoadingBulkAlarms) {
                            <div class="bulk-loading-indicator">
                              <mat-spinner diameter="24"></mat-spinner>
                              <span>Cargando...</span>
                            </div>
                          }
                          @if (!bulkHasMorePages && bulkAlarms.length > 0 && !isLoadingBulkAlarms) {
                            <div class="bulk-end-indicator">
                              <span>Total: {{ bulkAlarms.length }} alarmas cargadas</span>
                            </div>
                          }
                          @if (bulkAlarms.length === 0 && !isLoadingBulkAlarms) {
                            <div class="bulk-empty">Sin alarmas disponibles</div>
                          }
                        </div>
                        @if (selectedAlarmIds.size === 0 && bulkAlarms.length > 0) {
                          <div class="error-message" style="padding: 6px 12px;">
                            Debe seleccionar al menos una alarma
                          </div>
                        }
                      </div>
                    }
                    <div class="form-group">
                      <label for="status">Estado:</label>
                      <select id="status" formControlName="status" class="form-control">
                        <option value="" selected>Seleccione un estado</option>
                        @for (option of statusOptions; track option) {
                          <option [value]="option.value">
                            {{ option.label }}
                          </option>
                        }
                      </select>
                      @if (classificationForm.get('status')?.invalid && classificationForm.get('status')?.touched) {
                        <div class="error-message"
                          >
                          Estado es requerido
                        </div>
                      }
                    </div>
                    <div class="form-group">
                      <label for="observations">Observaciones:</label>
                      <textarea id="observations" formControlName="observations" class="form-control" rows="3"
                        placeholder="Ingrese observaciones sobre la alarma">
                      </textarea>
                      @if (classificationForm.get('observations')?.invalid && classificationForm.get('observations')?.touched) {
                        <div class="error-message"
                          >
                          Observaciones es requerido
                        </div>
                      }
                    </div>
                    <!-- <div class="form-actions">
                    <button type="button" class="btn btn-secondary" (click)="closeClassificationModal()">Cancelar</button>
                    <button type="submit" class="btn btn-primary"
                      [disabled]="classificationForm.invalid || (classificationForm.get('bulkClassification')?.value && selectedAlarmIds.size === 0)">
                      Enviar Clasificación
                    </button>
                  </div> -->
                  @if (errorMessage) {
                    <div class="alert alert-danger">{{ errorMessage }}</div>
                  }
                  @if (successMessage) {
                    <div class="alert alert-success">{{ successMessage }}</div>
                  }
                </div>
              </div>
              <div class="modal-footer">
                <div class="form-actions">
                  <button type="button" class="btn btn-secondary" (click)="closeClassificationModal()">Cancelar</button>
                  <button type="submit" class="btn btn-primary"
                    [disabled]="classificationForm.invalid || (classificationForm.get('bulkClassification')?.value && selectedAlarmIds.size === 0)">
                    Enviar Clasificación
                  </button>
                </div>
              </div>
            </form>
          </div>
        </div>
      }

      <!-- Modo evaluación de riesgo: tabla original -->
      @if (displayedPositions.length > 0 && isRiskEvaluation) {
        <div class="table-scroll-container">
          <table class="rs-table">
            <thead>
              <tr>
                @for (col of columns; track col) {
                  <th class="resizable-column sortable-column" (click)="sortTable(col)">
                    <div class="column-header-content">
                      {{ columnLabels[col] || col }}
                      @if (sortBy === col) {
                        <span class="sort-indicator" [class.sort-asc]="sortDirection === 'asc'"
                          [class.sort-desc]="sortDirection === 'desc'">
                          {{ sortDirection === 'asc' ? '▲' : '▼' }}
                        </span>
                      }
                    </div>
                  </th>
                }
              </tr>
            </thead>
            <tbody>
              @for (row of displayedPositions; track row) {
                <tr (click)="onVehicleSelected(row)" class="clickable-row"
                  [title]="row.assetName || 'Vehículo'">
                  @for (col of columns; track col) {
                    <td>{{ row[col] }}</td>
                  }
                </tr>
              }
            </tbody>
          </table>
        </div>
      }

      <!-- Sin alarmas ni posiciones -->
      @if (alarms.length === 0 && displayedPositions.length === 0) {
        <div class="no-alarms-message">
          <i class="material-icons" style="font-size: 48px; color: rgba(0,0,0,0.2); margin-bottom: 8px;">notifications_off</i>
          <p>No hay alarmas para mostrar</p>
        </div>
      }
    </div>
  </div>
</div>
</div>